import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";

import axios from "../axiosConfig";

import { useNavigate, useSearchParams } from "react-router-dom";

import { useToast } from "../context/ToastContext";

import RfpRequirementGrid from "../components/RfpRequirementGrid";

import RfpProcessHeader from "../components/rfp/RfpProcessHeader";

import RfpSelector from "../components/rfp/RfpSelector";

import { StatusBadge } from "../components/rfp/RfpJobCard";

import RfpOutlineReview from "../components/rfp/RfpOutlineReview";

import RfpCoachMarks from "../components/rfp/RfpCoachMarks";


import RfpShortcutsModal from "../components/rfp/RfpShortcutsModal";

import RfpJobToolbar from "../components/rfp/RfpJobToolbar";
import RfpExcelImportErrors from "../components/rfp/RfpExcelImportErrors";
import RfpComplianceDrawer from "../components/rfp/RfpComplianceDrawer";

import RfpEvidenceDrawer from "../components/rfp/RfpEvidenceDrawer";

import RfpScopeDiscoveryView from "../components/rfp/RfpScopeDiscoveryView";
import RfpScopeAnalysisView, { RfpScopeAnalysisActions } from "../components/rfp/RfpScopeAnalysisView";
import RfpSheetSelectPanel from "../components/rfp/RfpSheetSelectPanel";
import { isRfpExcelFile } from "../components/rfp/RfpUploadZone";

import { displayCountry, displayCustomer, displayOwnerSe, displayPageRanges, displayRfpVersion, isValidPageRangesInput, sourceBasename } from "../components/rfp/rfpUtils";
import { analysisPhaseLabel, runAnalysisPipeline } from "../components/rfp/analysisPipeline";
import { hasSupportedRfpDocument, loadScopeDiscovery as fetchScopeDiscovery, runScopeDiscovery, saveScopeDiscoveryReview } from "../components/rfp/scopeDiscoveryApi";
import { countOpenProductRows } from "../components/rfp/productDecision";
import { loadScopeAnalysis as fetchScopeAnalysis, runScopeAnalysis } from "../components/rfp/scopeAnalysisApi";



const API = "/api";


const COMPLIANCE_RUNNING = new Set(["queued", "processing", "primary_complete", "fallback_processing"]);



export default function RfpFeeder() {

  const navigate = useNavigate();

  const toast = useToast();

  const [searchParams, setSearchParams] = useSearchParams();

  const jobId = searchParams.get("job");



  const [file, setFile] = useState(null);

  const [customerName, setCustomerName] = useState("");

  const [ownerSe, setOwnerSe] = useState("");

  const [country, setCountry] = useState("");

  const [rfpVersion, setRfpVersion] = useState("");

  const [email, setEmail] = useState("");

  const [pageRanges, setPageRanges] = useState("");

  const [pageScope, setPageScope] = useState("");

  const [uploadTouched, setUploadTouched] = useState(false);

  const [jobMeta, setJobMeta] = useState(null);

  const [outline, setOutline] = useState(null);

  const [validation, setValidation] = useState(null);

  const [recentJobs, setRecentJobs] = useState([]);
  const [libraryPeriod, setLibraryPeriod] = useState("12m");
  const [availableYears, setAvailableYears] = useState([]);

  const [pipelineBusy, setPipelineBusy] = useState(false);

  const [activeJobs, setActiveJobs] = useState([]);

  const [busy, setBusy] = useState(false);

  const [reprocessing, setReprocessing] = useState(false);

  const [gridKey, setGridKey] = useState(0);

  const [gridDirty, setGridDirty] = useState(false);

  const [shortcutsOpen, setShortcutsOpen] = useState(false);


  const [jobView, setJobView] = useState("analysis_scope");
  const [decisionFocusId, setDecisionFocusId] = useState(null);
  const [productDecisionFocus, setProductDecisionFocus] = useState(0);
  const [requirementRows, setRequirementRows] = useState(null);
  const [liveOpenProductRows, setLiveOpenProductRows] = useState(null);
  const [showScopeReview, setShowScopeReview] = useState(false);

  const [analysis, setAnalysis] = useState(null);

  const [analysisStatus, setAnalysisStatus] = useState(null);

  const [generationStatus, setGenerationStatus] = useState(null);

  const [inheritedUnitsById, setInheritedUnitsById] = useState({});

  const [reviewRowIds, setReviewRowIds] = useState(() => new Set());

  const [analysisLoading, setAnalysisLoading] = useState(false);

  const [analysisError, setAnalysisError] = useState(null);

  const [regeneratingAnalysis, setRegeneratingAnalysis] = useState(false);
  const [importingExcel, setImportingExcel] = useState(false);
  const [excelImportErrors, setExcelImportErrors] = useState(null);
  const excelInputRef = useRef(null);
  const [compliance, setCompliance] = useState(null);
  const [complianceRow, setComplianceRow] = useState(null);

  const [analysisGenerationPhase, setAnalysisGenerationPhase] = useState(null);
  const [awaitingAutoAnalysis, setAwaitingAutoAnalysis] = useState(false);

  const [evidenceRowId, setEvidenceRowId] = useState(null);

  const [scrollToRowId, setScrollToRowId] = useState(null);

  const [scopeDiscovery, setScopeDiscovery] = useState(null);
  const [scopeDiscoveryRunning, setScopeDiscoveryRunning] = useState(false);
  const [scopeDiscoveryError, setScopeDiscoveryError] = useState(null);
  const [scopeDiscoverySaving, setScopeDiscoverySaving] = useState(false);
  const [scopeAnalysis, setScopeAnalysis] = useState(null);
  const [scopeAnalysisLoading, setScopeAnalysisLoading] = useState(false);
  const [scopeAnalysisError, setScopeAnalysisError] = useState(null);
  const [regeneratingScopeAnalysis, setRegeneratingScopeAnalysis] = useState(false);
  const [technologyReviewAnalysis, setTechnologyReviewAnalysis] = useState(false);
  const technologyReviewStarted = useRef(null);
  const sawTechnologyReviewRunning = useRef(false);


  const prevJobStatus = useRef(null);

  const uploadRef = useRef(null);

  const selectorRef = useRef(null);
  const [sheetStarting, setSheetStarting] = useState(false);
  const [sheetError, setSheetError] = useState(null);



  const pipelineRunning =

    reprocessing ||

    sheetStarting ||

    jobMeta?.status === "queued" ||

    jobMeta?.status === "processing";

  const pipelineStep = jobMeta?.pipeline_step || "";
  const auditRunning =
    pipelineStep === "auditing" || jobMeta?.grid_segmentation_status === "running";

  const autoAnalysisRunning =
    scopeDiscovery?.status === "running" ||
    scopeAnalysis?.status?.status === "running" ||
    awaitingAutoAnalysis ||
    scopeDiscoveryRunning ||
    regeneratingScopeAnalysis ||
    pipelineStep === "discovering_scope" ||
    pipelineStep === "auditing" ||
    pipelineStep === "assigning_labels" ||
    pipelineStep === "checking_compliance" ||
    auditRunning;






  const customerValid = customerName.trim().length > 0;

  const ownerSeValid = ownerSe.trim().length > 0;

  const countryValid = country.trim().length > 0;

  const fileValid = !!file;
  const isExcelUpload = isRfpExcelFile(file);

  const pageRangesValid =
    isExcelUpload ||
    pageScope === "entire_document" ||
    (pageScope === "specific_pages" && pageRanges.trim().length > 0 && isValidPageRangesInput(pageRanges));

  const canUpload = ownerSeValid && customerValid && countryValid && fileValid && pageRangesValid && !busy;



  const loadRecent = useCallback(async () => {

    try {

      const params = libraryPeriod === "12m" ? { range: "12m" } : { year: libraryPeriod };
      const res = await axios.get(`${API}/rfp-jobs`, { params });

      setRecentJobs(res.data?.jobs || []);
      setAvailableYears(res.data?.available_years || []);

      setPipelineBusy(!!res.data?.pipeline_busy);

      setActiveJobs(res.data?.active_jobs || []);

    } catch {

      setRecentJobs([]);

      setPipelineBusy(false);

      setActiveJobs([]);

    }

  }, [libraryPeriod]);



  const loadJob = useCallback(async (id) => {

    if (!id) {

      setJobMeta(null);

      setOutline(null);

      setValidation(null);

      return;

    }

    try {

      const [metaRes, outlineRes, valRes] = await Promise.all([

        axios.get(`${API}/rfp-jobs/${id}`),

        axios.get(`${API}/rfp-jobs/${id}/outline`).catch(() => ({ data: null })),

        axios.get(`${API}/rfp-jobs/${id}/outline-validation`).catch(() => ({ data: null })),

      ]);

      setJobMeta(metaRes.data);

      setOutline(outlineRes.data);

      setValidation(valRes.data);

    } catch (err) {

      toast.error(err?.response?.data?.detail || err.message || "Failed to load job");

      setJobMeta(null);

    }

  }, [toast]);



  const loadAnalysisMeta = useCallback(async (id) => {

    if (!id) {

      setAnalysisStatus(null);

      setGenerationStatus(null);

      setInheritedUnitsById({});

      setReviewRowIds(new Set());

      return;

    }

    try {

      const [statusRes, unitsRes, reqRes] = await Promise.all([
        axios.get(`${API}/rfp-jobs/${id}/analysis/v2/status`).catch(() => ({ data: null })),
        axios
          .get(`${API}/rfp-jobs/${id}/analysis/v2/inherited-units`)
          .catch(() => ({ data: null })),
        axios.get(`${API}/rfp-jobs/${id}/requirements`).catch(() => ({ data: null })),
      ]);

      const status = statusRes.data || { analysis_available: false, pipeline_version: "v2" };

      setAnalysisStatus(status);

      setGenerationStatus(status);

      const units = {};

      for (const unit of unitsRes.data?.units || []) {

        if (unit?.id) units[unit.id] = unit;

      }

      setInheritedUnitsById(units);

      setReviewRowIds(new Set((reqRes.data?.requirements || []).map((row) => row.id).filter(Boolean)));

    } catch {

      setAnalysisStatus(null);

      setGenerationStatus(null);

      setInheritedUnitsById({});

      setReviewRowIds(new Set());

    }

  }, []);

  const loadCompliance = useCallback(async (id) => {
    if (!id) {
      setCompliance(null);
      return null;
    }
    try {
      const res = await axios.get(`${API}/rfp-jobs/${id}/compliance`);
      setCompliance(res.data || null);
      return res.data;
    } catch {
      setCompliance(null);
      return null;
    }
  }, []);

  const loadScopeAnalysis = useCallback(async (id) => {
    if (!id) {
      setScopeAnalysis(null);
      setScopeAnalysisError(null);
      return null;
    }
    setScopeAnalysisLoading(true);
    setScopeAnalysisError(null);
    try {
      const data = await fetchScopeAnalysis(id, { http: axios, apiBase: API });
      setScopeAnalysis(data);
      return data;
    } catch (err) {
      setScopeAnalysisError(err?.response?.data?.detail || err.message || "Failed to load Scope Analysis");
      return null;
    } finally {
      setScopeAnalysisLoading(false);
    }
  }, []);

  const loadScopeDiscovery = useCallback(async (id) => {
    if (!id) {
      setScopeDiscovery(null);
      setScopeDiscoveryError(null);
      return null;
    }
    try {
      const data = await fetchScopeDiscovery(id, { http: axios, apiBase: API });
      setScopeDiscovery(data);
      return data;
    } catch {
      setScopeDiscovery(null);
      return null;
    }
  }, []);

  const loadAnalysis = useCallback(async (id) => {

    if (!id) {

      setAnalysis(null);

      setAnalysisError(null);

      return;

    }

    setAnalysisLoading(true);

    setAnalysisError(null);

    try {

      await loadAnalysisMeta(id);

      const pipelineVersion = "v2";
      const res = await axios.get(`${API}/rfp-jobs/${id}/analysis/${pipelineVersion}`);

      setAnalysis(res.data);

      setAnalysisStatus((prev) => ({ ...(prev || {}), analysis_available: true, pipeline_version: pipelineVersion }));

    } catch (err) {

      if (err?.response?.status === 404) {

        setAnalysis(null);

        setAnalysisError(null);

      } else {

        setAnalysisError(err?.response?.data?.detail || err.message || "Failed to load analysis");

        setAnalysis(null);

      }

    } finally {

      setAnalysisLoading(false);

    }

  }, [loadAnalysisMeta]);

  useEffect(() => {

    loadRecent();

  }, [loadRecent]);



  useEffect(() => {

    const intervalMs = pipelineBusy || pipelineRunning ? 4000 : 15000;

    const timer = setInterval(loadRecent, intervalMs);

    return () => clearInterval(timer);

  }, [pipelineBusy, pipelineRunning, loadRecent]);

  useEffect(() => {
    if (!jobId) return undefined;
    let cancelled = false;
    axios
      .get(`${API}/rfp-jobs/${jobId}/requirements`)
      .then((res) => {
        if (!cancelled) setRequirementRows(res.data?.requirements || []);
      })
      .catch(() => {
        if (!cancelled) setRequirementRows([]);
      });
    return () => {
      cancelled = true;
    };
  }, [jobId, scopeDiscovery]);



  useEffect(() => {

    loadJob(jobId);

    loadAnalysisMeta(jobId);

    loadCompliance(jobId);
    loadScopeDiscovery(jobId);
    setScopeAnalysis(null);
    loadScopeAnalysis(jobId);
    setRequirementRows(null);
    setLiveOpenProductRows(null);

    setComplianceRow(null);

    setJobView("analysis_scope");
    setShowScopeReview(false);
    setScopeDiscoveryError(null);
    setAwaitingAutoAnalysis(false);
    setAnalysisGenerationPhase(null);

    if (!jobId) {

      setAnalysis(null);

    }

  }, [jobId, loadJob, loadAnalysisMeta, loadCompliance, loadScopeDiscovery, loadScopeAnalysis]);



  useEffect(() => {

    setExcelImportErrors(null);

  }, [jobId]);



  useEffect(() => {
    if (!jobId || !COMPLIANCE_RUNNING.has(compliance?.status)) return undefined;
    const timer = setInterval(() => {
      loadCompliance(jobId);
    }, 4000);
    return () => clearInterval(timer);
  }, [jobId, compliance?.status, loadCompliance]);



  useEffect(() => {
    if (jobView !== "analysis_scope" || !jobId) return;
    loadScopeAnalysis(jobId);
    if (showScopeReview) loadScopeDiscovery(jobId);
  }, [jobView, jobId, showScopeReview, loadScopeAnalysis, loadScopeDiscovery]);

  useEffect(() => {

    if (!jobId || !jobMeta) return undefined;

    if (!pipelineRunning) return undefined;

    const timer = setInterval(() => loadJob(jobId), 4000);

    return () => clearInterval(timer);

  }, [jobId, jobMeta, pipelineRunning, loadJob]);



  useEffect(() => {
    if (!jobId || !autoAnalysisRunning) return undefined;
    const timer = setInterval(() => {
      loadJob(jobId);
      loadScopeDiscovery(jobId);
      loadScopeAnalysis(jobId);
      loadCompliance(jobId);
    }, 4000);
    return () => clearInterval(timer);
  }, [jobId, autoAnalysisRunning, loadJob, loadScopeDiscovery, loadScopeAnalysis, loadCompliance]);

  useEffect(() => {
    sawTechnologyReviewRunning.current = false;
    technologyReviewStarted.current = null;
    setTechnologyReviewAnalysis(false);
  }, [jobId]);

  useEffect(() => {
    const pending = scopeAnalysis?.status?.technology_review_analysis_pending;
    const statusJobId = scopeAnalysis?.status?.job_id;
    if (!jobId || !pending || (statusJobId && statusJobId !== jobId)) return undefined;
    if (technologyReviewStarted.current === jobId) return undefined;
    technologyReviewStarted.current = jobId;
    setTechnologyReviewAnalysis(true);
    let cancelled = false;
    axios
      .post(`${API}/rfp-jobs/${jobId}/analysis/scope/rerun-technology-review`)
      .then(() => {
        if (!cancelled) loadScopeAnalysis(jobId);
      })
      .catch(() => {
        if (!cancelled) setTechnologyReviewAnalysis(false);
      });
    return () => {
      cancelled = true;
    };
  }, [jobId, scopeAnalysis?.status?.technology_review_analysis_pending, loadScopeAnalysis]);

  useEffect(() => {
    if (
      scopeAnalysis?.status?.status === "running" &&
      scopeAnalysis?.status?.trigger === "technology_review"
    ) {
      sawTechnologyReviewRunning.current = true;
      setTechnologyReviewAnalysis(true);
    }
  }, [scopeAnalysis?.status?.status, scopeAnalysis?.status?.trigger]);

  useEffect(() => {
    if (!jobId || !technologyReviewAnalysis) return undefined;
    const timer = setInterval(() => loadScopeAnalysis(jobId), 4000);
    return () => clearInterval(timer);
  }, [jobId, technologyReviewAnalysis, loadScopeAnalysis]);

  useEffect(() => {
    if (!technologyReviewAnalysis || !sawTechnologyReviewRunning.current) return;
    const status = scopeAnalysis?.status?.status;
    if (status === "completed") {
      sawTechnologyReviewRunning.current = false;
      setTechnologyReviewAnalysis(false);
      setGridKey((key) => key + 1);
      loadScopeDiscovery(jobId);
    } else if (status === "failed" || status === "blocked") {
      sawTechnologyReviewRunning.current = false;
      setTechnologyReviewAnalysis(false);
    }
  }, [technologyReviewAnalysis, scopeAnalysis?.status?.status, jobId, loadScopeDiscovery]);

  const noteTechnologyReview = (data) => {
    if (!data?.analysis_rerun) return;
    setTechnologyReviewAnalysis(true);
    loadScopeAnalysis(jobId);
  };

  useEffect(() => {
    const scopeStatus = scopeAnalysis?.status?.status;
    if (scopeStatus === "completed" || scopeStatus === "failed") {
      setAwaitingAutoAnalysis(false);
      setRegeneratingScopeAnalysis(false);
    }
    if (scopeDiscovery?.status === "failed" && !scopeAnalysis?.analysis) {
      setAwaitingAutoAnalysis(false);
      setRegeneratingScopeAnalysis(false);
    }
    const auditStatus = jobMeta?.grid_segmentation_status;
    if (auditStatus === "rejected" || auditStatus === "failed") {
      setAwaitingAutoAnalysis(false);
      setRegeneratingScopeAnalysis(false);
    }
  }, [scopeAnalysis?.status?.status, scopeAnalysis?.analysis, scopeDiscovery?.status, jobMeta?.grid_segmentation_status]);

  useEffect(() => {
    if (!jobId) return;
    if (scopeAnalysis?.analysis && awaitingAutoAnalysis) {
      setAwaitingAutoAnalysis(false);
      setGridKey((k) => k + 1);
    }
  }, [jobId, scopeAnalysis, awaitingAutoAnalysis]);



  useEffect(() => {

    if (!jobMeta) return;

    const prev = prevJobStatus.current;

    const cur = jobMeta.status;

    const wasRunning = prev === "queued" || prev === "processing" || reprocessing;

    if (wasRunning && cur === "completed") {

      setGridKey((k) => k + 1);

      toast.success("Reprocess finished — requirements grid updated.");

      setReprocessing(false);

      setAwaitingAutoAnalysis(true);
      setRegeneratingScopeAnalysis(true);
      setJobView("analysis_scope");
      setShowScopeReview(false);

      loadScopeDiscovery(jobId);
      loadScopeAnalysis(jobId);
      loadCompliance(jobId);

      loadRecent();

    } else if (wasRunning && cur === "failed") {

      setReprocessing(false);

      toast.error(jobMeta.error || "Processing failed.");

    }

    prevJobStatus.current = cur;

  }, [jobId, jobMeta, reprocessing, loadRecent, loadScopeDiscovery, loadScopeAnalysis, loadCompliance, toast]);



  const openJob = (id) => {

    if (gridDirty && !window.confirm("You have unsaved grid changes. Open another job anyway?")) return;

    setSearchParams({ job: id });

    setGridDirty(false);

  };



  const uploadBlocked = pipelineBusy || pipelineRunning;



  const handleUpload = async (e) => {

    e.preventDefault();

    setUploadTouched(true);

    if (uploadBlocked) {

      toast.error("A document is already being processed. Wait for it to finish.");

      return;

    }

    if (!canUpload) {

      toast.error(
        isExcelUpload
          ? "Owner SE, Customer, Country, and document are required."
          : pageRangesValid
          ? "Owner SE, Customer, Country, document, and page scope are required."
          : pageScope === "specific_pages"
            ? "Enter valid page ranges, such as 90-100, 405-600."
            : "Select Entire document or Specific pages."
      );

      return;

    }

    setBusy(true);

    try {

      const form = new FormData();

      form.append("file", file);

      form.append("customer_name", customerName.trim());

      form.append("owner_se", ownerSe.trim());

      form.append("country", country.trim());

      form.append("page_scope", isExcelUpload ? "entire_document" : pageScope);

      if (email.trim()) form.append("email", email.trim());

      if (pageScope === "specific_pages") form.append("page_ranges", pageRanges.trim());

      if (rfpVersion.trim()) form.append("rfp_version", rfpVersion.trim());

      const res = await axios.post(`${API}/rfp-upload`, form);

      const newId = res.data?.job_id;

      toast.success(res.data?.message || "Upload queued.");

      setFile(null);

      setOwnerSe("");

      setCustomerName("");

      setCountry("");

      setEmail("");

      setPageRanges("");

      setPageScope("");

      setRfpVersion("");

      setUploadTouched(false);

      await loadRecent();

      if (newId) {

        setSearchParams({ job: newId });

        setGridDirty(false);

      }

    } catch (err) {

      const detail = err?.response?.data?.detail;

      toast.error(detail || err.message || "Upload failed");

      if (err?.response?.status === 409) await loadRecent();

    } finally {

      setBusy(false);

    }

  };


  const handleSelectSheets = async ({ mode, selected_sheets }) => {
    if (!jobId) return;
    if (mode === "selected" && !(selected_sheets || []).length) {
      setSheetError("Select at least one worksheet.");
      return;
    }
    setSheetError(null);
    setSheetStarting(true);
    try {
      await axios.post(`${API}/rfp-jobs/${jobId}/select-sheets`, {
        mode,
        selected_sheets,
      });
      setJobMeta((prev) =>
        prev
          ? {
              ...prev,
              status: "queued",
              phase: "processing",
              selected_sheets: mode === "all" ? "*" : selected_sheets,
            }
          : prev
      );
      setAwaitingAutoAnalysis(true);
      setRegeneratingScopeAnalysis(true);
      setJobView("analysis_scope");
      setShowScopeReview(false);
      toast.success("Excel processing started.");
      await Promise.all([loadJob(jobId), loadRecent()]);
      loadScopeDiscovery(jobId);
      loadScopeAnalysis(jobId);
      loadCompliance(jobId);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setSheetError(detail || err.message || "Could not start Excel processing.");
    } finally {
      setSheetStarting(false);
    }
  };


  const handleDownloadExcel = async () => {
    if (!jobId) return;
    try {
      const res = await axios.get(`${API}/rfp-download/${jobId}/excel`, { responseType: "blob" });
      const customer = displayCustomer(jobMeta).replace(/[^\w\-]+/g, "_");
      const base = sourceBasename(jobMeta?.filename, jobId);
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${customer}_${base}_requirements.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success("Excel downloaded. Edit with dropdowns, then Import Excel.");
    } catch (err) {
      let detail = err?.response?.data?.detail || err.message || "Download failed";
      if (err?.response?.data instanceof Blob) {
        try {
          const parsed = JSON.parse(await err.response.data.text());
          detail = parsed.detail || parsed.message || detail;
        } catch {
          /* keep */
        }
      }
      toast.error(typeof detail === "string" ? detail : detail?.message || "Download failed");
    }
  };

  const handleDownloadComplianceExcel = async () => {
    if (!jobId) return;
    try {
      const res = await axios.get(`${API}/rfp-download/${jobId}/compliance-excel`, { responseType: "blob" });
      const customer = displayCustomer(jobMeta).replace(/[^\w\-]+/g, "_");
      const base = sourceBasename(jobMeta?.filename, jobId);
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${customer}_${base}_compliance.xlsx`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success("Compliance Excel downloaded.");
    } catch (err) {
      let detail = err?.response?.data?.detail || err.message || "Download failed";
      if (err?.response?.data instanceof Blob) {
        try {
          const parsed = JSON.parse(await err.response.data.text());
          detail = parsed.detail || parsed.message || detail;
        } catch {
          /* keep */
        }
      }
      toast.error(typeof detail === "string" ? detail : detail?.message || "Download failed");
    }
  };

  const handleImportExcelFile = async (event) => {
    const fileObj = event.target.files?.[0];
    event.target.value = "";
    if (!fileObj || !jobId) return;
    if (gridDirty && !window.confirm("Unsaved grid edits will be replaced by the Excel import. Continue?")) {
      return;
    }
    setImportingExcel(true);
    setExcelImportErrors(null);
    try {
      const formData = new FormData();
      formData.append("file", fileObj);
      const res = await axios.post(`${API}/rfp-jobs/${jobId}/requirements/import-excel`, formData);
      const s = res.data || {};
      toast.success(
        `Excel imported: ${s.updated || 0} updated, ${s.added || 0} added, ${s.deleted || 0} deleted, ${s.unchanged || 0} unchanged.`
      );
      if (s.analysis_stale) {
        toast.info("Analysis is stale. Regenerate analysis after you finish reviewing.");
      }
      setGridKey((k) => k + 1);
      await loadJob(jobId);
      await loadAnalysisMeta(jobId);
      await loadCompliance(jobId);
    } catch (err) {
      const detail = err?.response?.data?.detail;
      if (detail && typeof detail === "object") {
        const errs = Array.isArray(detail.errors) ? detail.errors : [];
        setExcelImportErrors({
          message: detail.message || "Import rejected. Fix the listed rows and try again.",
          errors: errs,
          errorCount: detail.error_count || errs.length,
        });
        toast.error(
          `Import rejected — ${detail.error_count || errs.length || "see"} error${
            (detail.error_count || errs.length) === 1 ? "" : "s"
          } listed below.`
        );
      } else {
        const message = (typeof detail === "string" && detail) || err.message || "Import failed";
        setExcelImportErrors({
          message,
          errors: [{ row: "", field: "file", value: fileObj.name, reason: message }],
          errorCount: 1,
        });
        toast.error(message);
      }
    } finally {
      setImportingExcel(false);
    }
  };

  const checkingCompliance = COMPLIANCE_RUNNING.has(compliance?.status);
  const complianceProgressLabel = checkingCompliance
    ? `Checking ${compliance?.progress_current || 0} / ${compliance?.progress_total || 0}…`
    : "";
  const discoveryRunning = scopeDiscovery?.status === "running" || scopeDiscoveryRunning;
  const analysisRunning =
    scopeAnalysis?.status?.status === "running" || regeneratingScopeAnalysis;
  const technologyReviewRunning =
    technologyReviewAnalysis ||
    (scopeAnalysis?.status?.status === "running" &&
      scopeAnalysis?.status?.trigger === "technology_review");
  let processTitle = "";
  let processDetail = "";
  if (pipelineRunning) {
    processTitle = "Reading the document…";
    processDetail = "Typically 5–10 minutes, depending on the size of the RFP.";
  } else if (checkingCompliance || pipelineStep === "checking_compliance") {
    processTitle =
      compliance?.status === "fallback_processing" || compliance?.stage === "fallback"
        ? "Running the compliance fallback…"
        : "Checking compliance…";
    processDetail = compliance?.progress_total
      ? `${compliance.progress_current || 0} of ${compliance.progress_total}`
      : "";
  } else if (auditRunning && !analysisRunning) {
    processTitle = "Auto auditing is taking place";
  } else if (discoveryRunning || pipelineStep === "discovering_scope") {
    processTitle = "Discovering the RFP scope…";
  } else if (technologyReviewRunning) {
    processTitle = "Re-Running Analysis, Please Wait.";
  } else if (analysisRunning || pipelineStep === "assigning_labels") {
    processTitle = "Assigning technology and class…";
  }
  const auditFailed =
    (jobMeta?.grid_segmentation_status === "rejected" ||
      jobMeta?.grid_segmentation_status === "failed") &&
    !pipelineRunning &&
    !discoveryRunning &&
    !analysisRunning &&
    pipelineStep !== "discovering_scope" &&
    pipelineStep !== "auditing" &&
    pipelineStep !== "assigning_labels";
  const auditFailureMessage = auditFailed
    ? "The automatic grid audit failed, so analysis and compliance did not start. Reprocess the document to run them again."
    : "";

  const startComplianceCheck = async ({ allEligible = false, requirementIds = null } = {}) => {
    if (!jobId) return;
    if (checkingCompliance) {
      toast.info("A compliance check is already running.");
      return;
    }
    if (gridDirty && !window.confirm("There are unsaved grid edits. Check the last saved requirements anyway?")) {
      return;
    }
    try {
      const res = await axios.post(`${API}/rfp-jobs/${jobId}/compliance/check`, {
        all_eligible: allEligible,
        requirement_ids: requirementIds,
      });
      setCompliance(res.data || null);
      toast.info(allEligible ? "Compliance check started." : "Re-checking this requirement.");
    } catch (err) {
      const detail = err?.response?.data?.detail || err.message || "Compliance check failed";
      toast.error(typeof detail === "string" ? detail : detail?.message || "Compliance check failed");
      await loadCompliance(jobId);
    }
  };

  const handleExport = (exportId) => {
    if (exportId === "excel") handleDownloadExcel();
    else if (exportId === "compliance_excel") handleDownloadComplianceExcel();
  };

  const handleRegenerateAnalysis = async () => {
    if (!jobId) return;
    setRegeneratingAnalysis(true);
    setAnalysisGenerationPhase("extracting");
    setAnalysisError(null);
    try {
      await runAnalysisPipeline(jobId, {
        http: axios,
        apiBase: API,
        onPhase: setAnalysisGenerationPhase,
      });
      toast.info("Analysis pipeline complete.");
      await loadAnalysisMeta(jobId);
      await loadAnalysis(jobId);
      toast.success("Analysis generated.");
    } catch (err) {
      const detail = err?.response?.data?.detail || err.message || "Analysis generation failed";
      setAnalysisError(detail);
      toast.error(detail);
    } finally {
      setRegeneratingAnalysis(false);
      setAnalysisGenerationPhase(null);
    }
  };

  const handleRegenerateScopeAnalysis = async () => {
    if (!jobId) return;
    setRegeneratingScopeAnalysis(true);
    setScopeAnalysisError(null);
    try {
      await runScopeAnalysis(jobId, { http: axios, apiBase: API });
      toast.success("RFP Discovery Scope Analysis generated.");
      await loadScopeAnalysis(jobId);
      setGridKey((k) => k + 1);
    } catch (err) {
      const detail = err?.response?.data?.detail || err.message || "RFP Discovery Scope Analysis failed";
      setScopeAnalysisError(typeof detail === "string" ? detail : "RFP Discovery Scope Analysis failed");
      toast.error(typeof detail === "string" ? detail : "RFP Discovery Scope Analysis failed");
      await loadScopeAnalysis(jobId);
    } finally {
      setRegeneratingScopeAnalysis(false);
    }
  };

  const analysisBusy = regeneratingAnalysis || autoAnalysisRunning;
  const analysisGenerationLabel = analysisBusy
    ? analysisPhaseLabel(analysisGenerationPhase || generationStatus?.phase) || "Working…"
    : null;

  const handleDiscoverRfpScope = async () => {
    if (!jobId || scopeDiscoveryRunning) return;
    setJobView("analysis_scope");
    setShowScopeReview(true);
    if (scopeDiscovery?.status === "completed") {
      const again = window.confirm("A Scope Discovery result already exists. Run again?");
      if (!again) return;
    }
    setScopeDiscoveryRunning(true);
    setScopeDiscoveryError(null);
    try {
      const data = await runScopeDiscovery(jobId, { http: axios, apiBase: API });
      setScopeDiscovery(data);
      toast.success("RFP Scope Discovery complete. Generating Analysis…");
      setRegeneratingScopeAnalysis(true);
      const started = Date.now();
      while (Date.now() - started < 900_000) {
        await new Promise((resolve) => setTimeout(resolve, 4000));
        const payload = await fetchScopeAnalysis(jobId, { http: axios, apiBase: API });
        const status = payload?.status?.status;
        if (status === "completed" && payload?.analysis) {
          setScopeAnalysis(payload);
          toast.success("RFP Discovery Scope Analysis generated.");
          break;
        }
        if (status === "failed") {
          setScopeAnalysisError(payload?.status?.error || "RFP Discovery Scope Analysis failed");
          toast.error(payload?.status?.error || "RFP Discovery Scope Analysis failed");
          break;
        }
      }
    } catch (err) {
      const detail = err?.response?.data?.detail || err.message || "RFP Scope Discovery failed";
      setScopeDiscoveryError(typeof detail === "string" ? detail : "RFP Scope Discovery failed");
      toast.error(typeof detail === "string" ? detail : "RFP Scope Discovery failed");
      await loadScopeDiscovery(jobId);
    } finally {
      setScopeDiscoveryRunning(false);
      setRegeneratingScopeAnalysis(false);
    }
  };

  const handleScopeApprove = async (item) => {
    if (!jobId || !item?.item_id) return;
    setScopeDiscoverySaving(true);
    try {
      const data = await saveScopeDiscoveryReview(
        jobId,
        { updates: [{ item_id: item.item_id, review_status: "approved" }] },
        { http: axios, apiBase: API }
      );
      setScopeDiscovery(data);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not save review.");
    } finally {
      setScopeDiscoverySaving(false);
    }
  };

  const handleScopeReject = async (item) => {
    if (!jobId || !item?.item_id) return;
    setScopeDiscoverySaving(true);
    try {
      const data = await saveScopeDiscoveryReview(
        jobId,
        { updates: [{ item_id: item.item_id, review_status: "rejected" }] },
        { http: axios, apiBase: API }
      );
      setScopeDiscovery(data);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not save review.");
    } finally {
      setScopeDiscoverySaving(false);
    }
  };

  const handleScopeSaveEdit = async (item, fields) => {
    if (!jobId || !item?.item_id) return;
    setScopeDiscoverySaving(true);
    try {
      const data = await saveScopeDiscoveryReview(
        jobId,
        { updates: [{ item_id: item.item_id, ...fields }] },
        { http: axios, apiBase: API }
      );
      setScopeDiscovery(data);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not save edits.");
    } finally {
      setScopeDiscoverySaving(false);
    }
  };

  const handleScopeSaveDesign = async (update) => {
    if (!jobId || !update?.path) return;
    setScopeDiscoverySaving(true);
    try {
      const data = await saveScopeDiscoveryReview(
        jobId,
        { design_updates: [update] },
        { http: axios, apiBase: API }
      );
      setScopeDiscovery(data);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not save design edits.");
    } finally {
      setScopeDiscoverySaving(false);
    }
  };

  const handleScopeAddItem = async (section, payload) => {
    if (!jobId) return;
    setScopeDiscoverySaving(true);
    try {
      const data = await saveScopeDiscoveryReview(
        jobId,
        { add_items: [{ section, payload }] },
        { http: axios, apiBase: API }
      );
      setScopeDiscovery(data);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not add item.");
    } finally {
      setScopeDiscoverySaving(false);
    }
  };

  const handleEvidenceClick = (rowId) => {
    setEvidenceRowId(rowId);
  };

  const handleOpenEvidenceInReview = (rowId) => {
    setEvidenceRowId(null);
    setJobView("review");
    setScrollToRowId(rowId);
  };

  const evidenceUnit = evidenceRowId ? inheritedUnitsById[evidenceRowId] || null : null;
  const evidenceReviewRowId =
    evidenceUnit?.source_row_id && reviewRowIds.has(evidenceUnit.source_row_id)
      ? evidenceUnit.source_row_id
      : null;



  const handleReprocess = async () => {

    if (!jobId) return;

    setReprocessing(true);

    try {

      await axios.post(`${API}/rfp-jobs/${jobId}/reprocess`);

      toast.info("Reprocessing document… usually 5–10 minutes, depending on the size of the RFP.");

      await loadJob(jobId);

      await loadRecent();

    } catch (err) {

      toast.error(err?.response?.data?.detail || err.message || "Reprocess failed");

      setReprocessing(false);

    }

  };



  const handleDeleteJob = async () => {

    if (!jobId) return;

    const name = displayCustomer(jobMeta);

    if (!window.confirm(`Delete job "${name}" and all its files? This cannot be undone.`)) return;

    setBusy(true);

    try {

      await axios.delete(`${API}/rfp-jobs/${jobId}`);

      toast.success("Job deleted.");

      setSearchParams({});

      setJobMeta(null);

      setGridDirty(false);

      await loadRecent();

    } catch (err) {

      toast.error(err?.response?.data?.detail || err.message || "Delete failed");

    } finally {

      setBusy(false);

    }

  };



  const copyJobId = async () => {

    try {

      await navigator.clipboard.writeText(jobId);

      toast.success("Job ID copied.");

    } catch {

      toast.error("Could not copy job ID.");

    }

  };



  const openProductRowCount =
    liveOpenProductRows ??
    (requirementRows ? countOpenProductRows(scopeDiscovery?.scope, requirementRows) : 0);

  const showGrid =

    jobMeta &&

    !pipelineRunning &&

    jobMeta.status !== "awaiting_sheet_selection" &&

    (jobMeta.phase === "extracted" ||

      jobMeta.phase === "reviewed" ||

      jobMeta.artifacts?.document ||

      (jobMeta.status === "completed" && (jobMeta.row_count || 0) > 0));



  const showOutlineReview =

    jobMeta &&

    (jobMeta.phase === "needs_review" || jobMeta.review_required);



  const complianceEvaluated =
    (compliance?.summary?.compliant || 0) +
    (compliance?.summary?.partial || 0) +
    (compliance?.summary?.non_compliant || 0);
  const isScopeAnalysisView = jobView === "analysis_scope";
  const isReviewView = jobView === "review";

  const exportOptions = useMemo(() => {
    if (isScopeAnalysisView) return [];
    const opts = [];
    if (jobMeta?.artifacts?.document || showGrid) {
      opts.push({ id: "excel", label: "Excel (review & re-import)" });
    }
    return opts;
  }, [jobMeta, showGrid, isScopeAnalysisView]);



  const fieldCls =

    "rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm disabled:opacity-60 dark:border-slate-700 dark:bg-slate-950";



  return (

    <div className="space-y-5 pb-20">

      <RfpCoachMarks />



      <section
        className={
          jobId
            ? "rounded-lg border border-slate-200 bg-white px-4 py-2.5 dark:border-slate-800 dark:bg-slate-900/80"
            : "relative overflow-hidden rounded-2xl border border-slate-200 bg-white p-4 shadow-sm dark:border-slate-800 dark:bg-slate-900/80 sm:p-5"
        }
      >
        {!jobId ? (
          <div className="absolute inset-x-0 top-0 h-16 bg-gradient-to-r from-emerald-500/15 via-teal-500/10 to-cyan-500/15" />
        ) : null}

        <div className="relative flex flex-wrap items-center justify-between gap-3">
          <div>
            {jobId ? (
              <h1 className="text-base font-semibold tracking-tight text-slate-900 dark:text-white">
                RFP Feeder
              </h1>
            ) : (
              <>
                <p className="text-xs font-semibold uppercase tracking-[0.2em] text-emerald-700 dark:text-emerald-300">
                  RFP AI Assistant
                </p>
                <h1 className="text-xl font-semibold tracking-tight sm:text-2xl">
                  Upload, review, and refine requirements
                </h1>
              </>
            )}
          </div>

          <button
            type="button"
            className="rounded-lg border border-slate-300 px-3 py-1.5 text-sm text-slate-700 hover:bg-slate-50 dark:border-slate-700 dark:text-slate-200 dark:hover:bg-slate-800"
            onClick={() => navigate(-1)}
          >
            Back
          </button>
        </div>
      </section>



      <div ref={uploadRef}>

        <RfpSelector

          selectorRef={selectorRef}

          jobs={recentJobs}

          libraryPeriod={libraryPeriod}

          availableYears={availableYears}

          onLibraryPeriodChange={setLibraryPeriod}

          activeJobId={jobId}

          jobMeta={jobMeta}

          onOpenJob={openJob}

          file={file}

          onFile={setFile}

          customerName={customerName}

          setCustomerName={setCustomerName}

          ownerSe={ownerSe}

          setOwnerSe={setOwnerSe}

          country={country}

          setCountry={setCountry}

          email={email}

          setEmail={setEmail}

          pageRanges={pageRanges}

          setPageRanges={setPageRanges}

          pageScope={pageScope}

          setPageScope={setPageScope}

          rfpVersion={rfpVersion}

          setRfpVersion={setRfpVersion}

          uploadTouched={uploadTouched}

          setUploadTouched={setUploadTouched}

          customerValid={customerValid}

          ownerSeValid={ownerSeValid}

          countryValid={countryValid}

          fileValid={fileValid}

          pageRangesValid={pageRangesValid}

          canUpload={canUpload}

          uploadBlocked={uploadBlocked}

          busy={busy}

          activeJobs={activeJobs}

          onUpload={handleUpload}

          fieldCls={fieldCls}

        />

      </div>



      {jobId && (

        <section className="rounded-xl border border-slate-200 bg-white p-4 dark:border-slate-800 dark:bg-slate-900/80 sm:p-5">

          <RfpProcessHeader
            jobView={jobView}
            onJobViewChange={(view) => {
              setDecisionFocusId(null);
              setJobView(view === "review" ? "review" : "analysis_scope");
              if (view === "review") setShowScopeReview(false);
            }}
            analysisAvailable={!!analysisStatus?.analysis_available}
            scopeAnalysisAvailable={!!scopeAnalysis?.analysis}
            showViewSwitch={showGrid && !showOutlineReview}
          />



          <div className="mb-3 flex flex-wrap items-start justify-between gap-3 border-b border-slate-200 pb-3 dark:border-slate-800">

            <div className="min-w-0 flex-1">

              <div className="flex flex-wrap items-center gap-2">

              </div>

              <p className="mt-0.5 text-sm text-slate-600 dark:text-slate-400">

                Owner SE: {displayOwnerSe(jobMeta)}

                {" "}

                · {displayCountry(jobMeta)}

                {displayRfpVersion(jobMeta) ? (

                  <>

                    {" "}

                    · {displayRfpVersion(jobMeta)}

                  </>

                ) : null}

                {jobMeta?.filename ? (

                  <>

                    {" "}

                    · File: <span className="text-slate-700 dark:text-slate-300">{jobMeta.filename}</span>

                  </>

                ) : null}

                {displayPageRanges(jobMeta) ? (

                  <>

                    {" "}

                    · Pages: <span className="text-slate-700 dark:text-slate-300">{displayPageRanges(jobMeta)}</span>

                  </>

                ) : null}

              </p>

              <div className="mt-1 flex flex-wrap items-center gap-2 text-xs text-slate-500">

                {jobMeta && <StatusBadge status={jobMeta.status} phase={jobMeta.phase} />}

                <button

                  type="button"

                  className="text-slate-500 underline decoration-slate-300 underline-offset-2 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200"

                  onClick={copyJobId}

                >

                  Copy job ID

                </button>

              </div>

            </div>

          </div>



          {processTitle && (

            <div className="mb-3 flex items-center gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-2.5 text-sm dark:border-amber-900/50 dark:bg-amber-950/30" data-testid="rfp-process-banner">

              <span className="inline-block h-5 w-5 animate-spin rounded-full border-2 border-amber-600 border-t-transparent" />

              <div>

                <p className="font-medium text-amber-950 dark:text-amber-100">{processTitle}</p>

                {processDetail ? (
                  <p className="text-xs text-amber-900/80 dark:text-amber-200/80">{processDetail}</p>
                ) : null}

              </div>

            </div>

          )}



          <div className="mb-3">
            <RfpJobToolbar
              exportOptions={exportOptions}
              onExport={handleExport}
              onExportCompliance={
                isReviewView && complianceEvaluated > 0 ? handleDownloadComplianceExcel : undefined
              }
              onImportExcel={isScopeAnalysisView ? undefined : () => excelInputRef.current?.click()}
              importingExcel={importingExcel}
              onCheckCompliance={
                isScopeAnalysisView || compliance?.configured === false
                  ? undefined
                  : () => startComplianceCheck({ allEligible: true })
              }
              checkingCompliance={checkingCompliance}
              complianceProgressLabel={complianceProgressLabel}
              onRefresh={() => {
                loadJob(jobId);
                loadCompliance(jobId);
                loadScopeDiscovery(jobId);
                loadScopeAnalysis(jobId);
              }}
              onReprocess={handleReprocess}
              reprocessing={reprocessing}
              pipelineRunning={pipelineRunning}
              onShortcuts={isScopeAnalysisView ? undefined : () => setShortcutsOpen(true)}
              onDelete={handleDeleteJob}
              deleteDisabled={busy}
              showRegenerateAnalysis={false}
            />
            <input
              ref={excelInputRef}
              type="file"
              accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              className="hidden"
              onChange={handleImportExcelFile}
            />
            {excelImportErrors && (
              <RfpExcelImportErrors
                message={excelImportErrors.message}
                errors={excelImportErrors.errors}
                errorCount={excelImportErrors.errorCount}
                filename={`${displayCustomer(jobMeta).replace(/[^\w\-]+/g, "_")}_${sourceBasename(jobMeta?.filename, jobId)}_import_errors.csv`}
                onDismiss={() => setExcelImportErrors(null)}
              />
            )}
            {compliance?.stale && (
              <p className="mt-3 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-950 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-100">
                Requirements changed — re-check compliance.
              </p>
            )}
            {openProductRowCount > 0 && (
              <p className="mt-3 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-950 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-100" data-testid="rfp-product-classification-banner">
                Product classification needs review.{" "}
                {showGrid ? (
                  <button
                    type="button"
                    className="font-medium underline"
                    onClick={() => {
                      setDecisionFocusId(null);
                      setJobView("review");
                      setShowScopeReview(false);
                      setProductDecisionFocus((current) => current + 1);
                    }}
                  >
                    Show the rows
                  </button>
                ) : null}
              </p>
            )}
            {compliance?.error_message && compliance?.status === "failed" && (
              <p className="mt-3 rounded-lg border border-rose-300 bg-rose-50 px-3 py-2 text-sm text-rose-900 dark:border-rose-800 dark:bg-rose-950/40 dark:text-rose-100">
                {compliance.error_message}
              </p>
            )}
            {compliance?.summary && (compliance.summary.compliant + compliance.summary.partial + compliance.summary.non_compliant + compliance.summary.error + compliance.summary.pending) > 0 && (
              <p className="mt-2 text-sm text-slate-600 dark:text-slate-300" data-testid="rfp-compliance-summary">
                Compliant {compliance.summary.compliant} · Partial {compliance.summary.partial} · Non-compliant {compliance.summary.non_compliant} · Error {compliance.summary.error}
                {compliance.summary.pending ? ` · Pending ${compliance.summary.pending}` : ""}
              </p>
            )}
          </div>



          {jobMeta?.status === "failed" && jobMeta?.error && (

            <p className="mb-3 text-sm text-red-600 dark:text-red-400">{jobMeta.error}</p>

          )}



          {showOutlineReview && (

            <RfpOutlineReview

              jobId={jobId}

              outline={outline}

              validation={validation}

              onToast={toast}

              onConfirmed={async () => {

                await loadJob(jobId);

                setGridKey((k) => k + 1);

              }}

            />

          )}



          {jobMeta?.status === "awaiting_sheet_selection" && !sheetStarting && (
            <RfpSheetSelectPanel
              sheets={jobMeta.sheets || []}
              onStart={handleSelectSheets}
              busy={sheetStarting}
              error={sheetError}
            />
          )}

          {showGrid && jobView === "analysis_scope" ? (
            showScopeReview ? (
              <div className="space-y-4">
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <div>
                    <h2 className="text-lg font-semibold text-slate-800 dark:text-slate-100">
                      Analysis (RFP Discovery Scope)
                    </h2>
                    <p className="text-sm text-slate-500">Review approved technologies and pages, then regenerate Analysis.</p>
                  </div>
                  <RfpScopeAnalysisActions
                    onReviewScope={() => setShowScopeReview(false)}
                    reviewing
                    onRegenerate={handleRegenerateScopeAnalysis}
                    regenerating={regeneratingScopeAnalysis}
                    blocked={!scopeAnalysis?.status?.approved_scope_ready && !scopeDiscovery}
                  />
                </div>
                <RfpScopeDiscoveryView
                  jobMeta={jobMeta}
                  result={scopeDiscovery}
                  loading={false}
                  running={scopeDiscoveryRunning}
                  error={scopeDiscoveryError || (scopeDiscovery?.status === "failed" ? scopeDiscovery.error : null)}
                  onApprove={handleScopeApprove}
                  onReject={handleScopeReject}
                  onSaveEdit={handleScopeSaveEdit}
                  onSaveDesign={handleScopeSaveDesign}
                  onAddItem={handleScopeAddItem}
                  onRunDiscovery={hasSupportedRfpDocument(jobMeta) ? handleDiscoverRfpScope : undefined}
                  saving={scopeDiscoverySaving}
                  jobId={jobId}
                  requirementRows={requirementRows}
                  onShowInGrid={(item) => {
                    setDecisionFocusId(item.item_id);
                    setJobView("review");
                    setShowScopeReview(false);
                  }}
                  onProductDecisionApplied={(data) => {
                    if (data?.result) setScopeDiscovery(data.result);
                    setGridKey((key) => key + 1);
                    noteTechnologyReview(data);
                  }}
                />
              </div>
            ) : (
              <RfpScopeAnalysisView
                payload={scopeAnalysis}
                loading={
                  !auditFailed &&
                  (scopeAnalysisLoading ||
                    awaitingAutoAnalysis ||
                    scopeAnalysis?.status?.status === "running")
                }
                error={scopeAnalysisError || auditFailureMessage}
                onRegenerate={handleRegenerateScopeAnalysis}
                regenerating={regeneratingScopeAnalysis}
                onEvidenceClick={handleEvidenceClick}
                onReviewScope={() => {
                  setShowScopeReview(true);
                  loadScopeDiscovery(jobId);
                }}
                reviewingScope={false}
              />
            )
          ) : showGrid ? (
            <RfpRequirementGrid
              key={`${jobId}-${gridKey}`}
              jobId={jobId}
              sourceFormat={jobMeta?.source_format || "pdf"}
              onToast={toast}
              onDirtyChange={({ dirty }) => setGridDirty(dirty)}
              onShowShortcuts={() => setShortcutsOpen(true)}
              scrollToRowId={scrollToRowId}
              onHighlightDone={() => setScrollToRowId(null)}
              complianceById={compliance?.results || {}}
              onOpenCompliance={(row) => setComplianceRow(row)}
              scopeResult={scopeDiscovery?.scope}
              decisionFocusId={decisionFocusId}
              productDecisionFocus={productDecisionFocus}
              onClearDecisionFocus={() => setDecisionFocusId(null)}
              onOpenProductRowCount={setLiveOpenProductRows}
              onProductDecisionApplied={(data) => {
                if (data?.result) setScopeDiscovery(data.result);
                noteTechnologyReview(data);
              }}
              onSaved={(data) => {
                setJobMeta((prev) =>
                  prev
                    ? {
                        ...prev,
                        phase: "reviewed",
                        row_count: data?.requirements?.length ?? prev.row_count,
                      }
                    : prev
                );
                setGridDirty(false);
                loadCompliance(jobId);
              }}
            />
          ) : (

            !pipelineRunning &&

            !showOutlineReview && (

              <p className="text-sm text-slate-500">Requirements grid will appear when processing completes.</p>

            )

          )}

        </section>

      )}



      <RfpShortcutsModal open={shortcutsOpen} onClose={() => setShortcutsOpen(false)} />

      <RfpEvidenceDrawer
        rowId={evidenceRowId}
        unit={evidenceUnit}
        reviewRowId={evidenceReviewRowId}
        onClose={() => setEvidenceRowId(null)}
        onOpenInReview={handleOpenEvidenceInReview}
      />
      <RfpComplianceDrawer
        row={complianceRow}
        result={complianceRow ? compliance?.results?.[complianceRow.id] : null}
        checking={checkingCompliance}
        onClose={() => setComplianceRow(null)}
        onRecheck={(id) => startComplianceCheck({ requirementIds: [id] })}
      />

    </div>

  );

}
